import { Tabs } from "antd";
import ServiceExpenseEntry from "./Service Expense Entry/ServiceExpenseEntry";
import ServiceExpenseRecord from "./ServiceExpenseRecord";
import ServiceExpenseVoucher from "./ServiceExpenseVoucher";
import { useLocation } from "react-router-dom";
import { accessChecker } from "../../../lib/functions";


const ServiceExpense = () => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const activeTab = params.get("tab") || "entry";

  const menuData = [
    {
      label: "Service Expense Entry",
      key: "entry",
      value: "service_expense_entry",
      children: (
        <>
          <ServiceExpenseEntry />
        </>
      ),
    },
    {
      label: "Service Expense Record",
      key: "record",
      value: "service_expense_record",
      children: (
        <>
          <ServiceExpenseRecord />
        </>
      ),
    },
    {
      label: "Service Expense Voucher",
      key: "voucher",
      value: "service_expense_voucher",
      children: (
        <>
          <ServiceExpenseVoucher />
        </>
      ),
    },
  ];

  const filteredMenuData = menuData.filter((menuItem) => accessChecker(menuItem.value));

  return (
    <Tabs
      defaultActiveKey={activeTab}
      type="card"
      size="medium"
      style={{ marginBottom: 32 }}
      items={filteredMenuData}
    />
  );
};

export default ServiceExpense;
